<script setup lang="ts">
import { watch } from "vue";
import ExclamationRhombus from "../../assets/icons/ExclamationRhombus.vue";
import InfoCard from "../InfoCard.vue";
import { ITransactionButton } from "./hooks/useReportTransactionButton";

const props = defineProps<{
  transactionStatus: ITransactionButton;
  showPopUp: boolean;
}>();

const emit = defineEmits<{
  (e: "update:showPopUp", value: boolean): void;
}>();

watch(
  () => props.showPopUp,
  (newValue) => {
    if (newValue) {
      setTimeout(() => {
        emit("update:showPopUp", false);
      }, 5000);
    }
  }
);
</script>

<template>
  <Transition name="fade">
    <div
      v-if="props.transactionStatus.transactionBtn.isGreyOut && props.showPopUp"
      class="container-pop-up"
    >
      <InfoCard
        :style="'alert'"
        class="report-transaction-error-card"
        containerCustomClass="report-transaction-error-card-container"
      >
        <ExclamationRhombus />
        <p class="report-transaction-error-card-p">
          {{ props.transactionStatus.transactionBtn.reasonForGreyOut }}
        </p>
      </InfoCard>
    </div>
  </Transition>
</template>

<style>
.container-pop-up {
  padding-top: 60px;
}
.report-transaction-error-card {
  background-color: #ffe4e6;
  padding: 16px;
  margin: 0px 8px;
}
.report-transaction-error-card-container {
  width: 100%;
  display: flex;
}
.report-transaction-error-card-p {
  color: #111111;
  margin: 0px !important;
  text-align: left;
  padding-left: 8px;
}
.fade-enter-from {
  transform: translateY(100px);
}
.fade-enter-active {
  transition: all 0.3s ease-in-out;
}
.fade-enter-to {
  transform: translateY(0);
}
.fade-leave-from {
  transform: translateY(0);
}
.fade-leave-active {
  transition: all 0.3s ease-in-out;
}
.fade-leave-to {
  transform: translateY(100px);
}
</style>
